import React from 'react';
import Loadable from 'react-loadable';

const LoadableWidget = Loadable({
  loader: () => import(/* webpackChunkName: "PokerHomeGamesWidget" */ './PokerHomeGamesWidget'),
  modules: ['./PokerHomeGamesWidget'],
  loading: () => <div />
});

export default LoadableWidget;
